/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Err_GroupInputs */

const en_messages_err_group = /** @type {(inputs: Messages_Err_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a group to send to.`)
};

const he_messages_err_group = /** @type {(inputs: Messages_Err_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחר קבוצה לשליחה.`)
};

/**
* | output |
* | --- |
* | "Pick a group to send to." |
*
* @param {Messages_Err_GroupInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_err_group = /** @type {((inputs?: Messages_Err_GroupInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Err_GroupInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_err_group(inputs)
	return he_messages_err_group(inputs)
});